<script context="module">
    import {derived, writable} from "svelte/store";
    import {doFetch} from '../lib/data.js';
    import {sortBy} from "lodash-es";

    let JWT;

    export const session = writable({
        loggedIn: false,
        user: {}
    });

    export const isAdmin = derived(session, (sess) => !!sess.user?.roles?.includes("admin"));

    function parseJwt(token) {
        try {
            return JSON.parse(atob(token.split('.')[1]));
        } catch (e) {
            return null;
        }
    };

    export async function getJWT() {
        return new Promise((resolve, reject) => {
            if (JWT) {
                let parsed_jwt = parseJwt(JWT);

                // check if jwt expires in the next minute
                if (parsed_jwt && parsed_jwt.exp > ((Date.now() / 1000) - 60)) {
                    resolve(JWT);
                    return;
                }
            }

            return doFetch('/api/auth/jwt').then(res => {
                res.json().then((result) => {
                    JWT = result.jwt;

                    resolve(result.jwt);
                });
            }).catch(err => {
                session.set({
                    loggedIn: false,
                    user: {}
                });
                reject(err);
            });
        });
    }

    export async function getUsers() {
        let users = await (await fetch('/api/auth/users/')).json()

        let user_choices = sortBy(users, ['name']).map((user) => {
            return {
                label: user.name,
                value: user.email
            }
        })

        return user_choices;
    }

    export const userMap = derived(session, async ($sess, set) => {
        if ($sess && $sess.loggedIn) {
            let users = await (await fetch('/api/auth/users/')).json()

            const user_map = Object.fromEntries(users.map((u) => [u.email, u.name]))
            set(user_map);
        }
    }, {})
</script>